import "./AddonComponent.css"
import CmsHelper, {PickProgramPageHelper} from "../../../Utilities/CmsHelpers";
import React from "react";
import {useCms} from "../../../../context/CmsContext";
import {useTranslation} from "react-i18next";

export default function AddonComponent({addons, }) {
    const {pickProgramData} = useCms();
    const { t } = useTranslation();

    if(!addons) return <></>;

    const pickAddons = PickProgramPageHelper.getPickAddons(PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT))?.addons;

    return <>
        <div className={"congratsaddon-addon-wraper"}>
            <span className={"congratsaddon-addon-wrapper-title"}>{t("congratsAddonReminderHeader")}</span>
            {addons.map((addon, index) => {
                const cmsData = PickProgramPageHelper.getAddon(pickAddons, addon?.skuORQuickCode)[0]
                if(!cmsData) return <></>
                return <>
                    <div key={index} className={"congratsaddon-content-container"}>
                        <div className={"congratsaddon-content-wrapper"}>
                            <img src={cmsData?.icon?.url} alt={`${addon?.skuORQuickCode} icon`}/>
                            <div>
                                <span className={"title"}>{cmsData?.title}</span>
                                <span className={"subtitle"}>{cmsData?.description}</span>
                            </div>
                        </div>
                        <div className={"congratsaddon-price-wrapper"}>
                            <span className={"before-price"}>{cmsData?.beforePrice}</span><span
                            className={"after-price"}>{cmsData?.afterPrice}</span>
                        </div>
                    </div>
                </>
            })
            }
        </div>
        </>
        }